<ng-container *ngIf="state === 'generateKey'; else displayKey">
  <h1 mat-dialog-title>{{ 'generateApiKeyDialog.title' | translate }}</h1>
  <button test-id="close-dialog" mat-icon-button mat-dialog-close (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
  <div mat-dialog-content>
    <form class="form-full-width" [formGroup]="form">
      <label [id]="getLabelId('key-name')">{{ 'generateApiKeyDialog.keyName' | translate }}<span class="red">*</span></label>
      <mat-form-field appearance="outline">
        <input
          matInput
          test-id="key-name"
          [id]="getLabelId('key-name')"
          [attr.aria-labelledby]="getLabelId('key-name')"
          [placeholder]="'generateApiKeyDialog.enterName' | translate"
          type="text"
          formControlName="keyName"
          autocomplete="off">
        <mat-error *ngIf="form.get('keyName').hasError('maxlength')">{{ 'common.errors.labelLong' | translate }}</mat-error>
        <mat-error *ngIf="form.get('keyName').hasError('minlength')">{{ 'common.errors.labelShort' | translate }}</mat-error>
        <mat-error *ngIf="form.get('keyName').hasError('required')">{{ 'common.errors.fieldRequired' | translate }}</mat-error>
      </mat-form-field>

      <label [id]="getLabelId('expiration-date')">{{ 'generateApiKeyDialog.expirationDate' | translate }}<span class="red">*</span></label>
      <span class="desc">{{ 'generateApiKeyDialog.expirationDescription' | translate }}</span>
      <mat-form-field appearance="outline">
        <input matInput [min]="minDate" formControlName="expirationDate" [matDatepicker]="expirationDatepicker">
        <mat-datepicker-toggle matSuffix [for]="expirationDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #expirationDatepicker></mat-datepicker>
        <mat-error *ngIf="form.get('expirationDate').hasError('required')">{{ 'generateApiKeyDialog.errors.validDate' | translate }}</mat-error>
        <mat-error *ngIf="form.get('expirationDate').hasError('matDatepickerMin')">{{ 'generateApiKeyDialog.errors.pastDate' | translate }}</mat-error>
      </mat-form-field>
    </form>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-dialog-close mat-stroked-button test-id="close-button">{{ 'common.actions.cancel' | translate }}</button>
    <button mat-flat-button [disabled]="form.invalid" test-id="save" color="primary" (click)="submit()">
      {{ 'generateApiKeyDialog.addKey' | translate }}
    </button>
  </div>
</ng-container>

<ng-template #displayKey>
  <h1 mat-dialog-title>{{ 'generateApiKeyDialog.generated' | translate }}</h1>
  <button test-id="close-dialog" mat-icon-button mat-dialog-close (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
  <div mat-dialog-content class="generated-api-confirmation">
    <div class="view-once-message"><mat-icon class="xs">error_outline</mat-icon>{{ 'generateApiKeyDialog.viewOnceMessage' | translate }}</div>
    <div class="section">
      <label [id]="getLabelId('key-name')">{{ 'generateApiKeyDialog.yourNewKey' | translate }}</label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput readonly [type]="showUnencryptedSecret ? 'text' : 'password'" [(ngModel)]="displayUnencryptedSecret">
        <mat-icon matSuffix (click)="showUnencryptedSecret = !showUnencryptedSecret">{{ showUnencryptedSecret ? 'visibility_off' : 'visibility' }}</mat-icon>
      </mat-form-field>
      <button mat-flat-button test-id="copy-secret-to-clipboard" class="copy-button" color="primary" (click)="copyToClipboard('secret')">
        <mat-icon class="xs content-copy">content_copy</mat-icon> {{ (secretCopied ? 'generateApiKeyDialog.copied' : 'generateApiKeyDialog.copyToClipboard') | translate }}
      </button>
    </div>
    <div class="section">
      <label [id]="getLabelId('cli-command')">{{ 'common.labels.flywheelCli' | translate }}</label>
      <div class="desc">{{ 'generateApiKeyDialog.cliDesc' | translate }}</div>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput readonly [type]="showCliCommand ? 'text' : 'password'" [(ngModel)]="displayCliCommand">
        <mat-icon matSuffix (click)="showCliCommand = !showCliCommand">{{ showCliCommand ? 'visibility_off' : 'visibility' }}</mat-icon>
      </mat-form-field>
      <button mat-flat-button test-id="copy-cli-to-clipboard" class="copy-button" color="primary" (click)="copyToClipboard('command')">
        <mat-icon class="xs content-copy">content_copy</mat-icon> {{ (CLICopied ? 'generateApiKeyDialog.copied' : 'generateApiKeyDialog.copyToClipboard') | translate }}
      </button>
    </div>
  </div>
</ng-template>
